import { render, staticRenderFns } from "./contentArticle.vue?vue&type=template&id=8d5cea0a&scoped=true&"
import script from "./contentArticle.vue?vue&type=script&lang=js&"
export * from "./contentArticle.vue?vue&type=script&lang=js&"
import style0 from "./contentArticle.vue?vue&type=style&index=0&id=8d5cea0a&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d5cea0a",
  null
  
)

export default component.exports